import { Text, Pill, Product } from "components/commons";
import styles from "./order-summary-list.module.scss";
import { dateTimeFormat, formatAmount, formatVolume } from "utils";
import ValidatedPopOverMenu from "./order-summary-menu";
import { OrderStatus } from "enums";
import { prettifyOrderStatus } from "utils/pretty.utils";
import { ProductCodeEnum } from "enums";
import { prettifyProductCode } from "utils/pretty.utils";

export const mapDataToList = ({ orders, history }) => {
  const {
    orderId,
    salesOrderNumber,
    status,
    orderItems,
    orderedAt,
    updatedAt,
    purchaseOrderNumber,
    station,
  } = orders;

  return {
    orderId: (
      <>
        <Text className={styles}>{orderId ?? ""}</Text>
      </>
    ),
    stationCode: (
      <>
        <Text className={styles.td}>{station?.stationCode ?? "-"}</Text>
      </>
    ),
    stationName: (
      <div className={styles.container150}>
        <Text className={styles.td}>{station?.name ?? "-"}</Text>
      </div>
    ),
    stationType: (
      <>
        <Text className={styles.td}>{station?.type ?? ""}</Text>
      </>
    ),
    products: (
      <>
        {orderItems.map((item) => (
          <Product
            key={item.productCode}
            grass={item.productCode === ProductCodeEnum.GAS91}
            salsa={item.productCode === ProductCodeEnum.GAS95}
            deepBlue={item.productCode === ProductCodeEnum.GAS97}
            cheddar={item.productCode === ProductCodeEnum.DIESEL}
          >
            <Text className={styles.td}>{prettifyProductCode(item.productCode)}</Text>
          </Product>
        ))}
      </>
    ),
    amountInKL: (
      <div className={styles.container100}>
        {orderItems?.map((item) => (
          <Text className={styles.td}>{formatVolume(item.volume / 1000, "KL") ?? ""}</Text>
        ))}
      </div>
    ),
    amountInPhp: (
      <div className={styles.container150}>
        {orderItems?.map((item) => (
          <Text className={styles.td}>{formatAmount(item.amount)}</Text>
        ))}
      </div>
    ),
    purchaseOrderNumber: (
      <div className={styles.container200}>
        <Text className={styles.td}>{purchaseOrderNumber ?? "-"}</Text>
      </div>
    ),
    salesOrderNumber: (
      <div className={styles.container200}>
        <Text className={styles.td}>{salesOrderNumber ?? "-"}</Text>
      </div>
    ),
    createdAt: (
      <div className={styles.container100}>
        <Text className={styles.td}>{dateTimeFormat(orderedAt)}</Text>
      </div>
    ),
    status: (
      <div className={styles.container100}>
        <Pill
          className={styles.status}
          cheddar={status === OrderStatus.ForRevision || status === OrderStatus.Pending}
          grass={status === OrderStatus.Delivered}
          cement={status === OrderStatus.Canceled}
          deepRed={status === OrderStatus.Rejected}
          sky={status === OrderStatus.Processing}
          purple={status === OrderStatus.ForDelivery}
          mainlyBlue={status === OrderStatus.ForApproval}
        >
          {prettifyOrderStatus(status)}
        </Pill>
        <Text
          style={{
            marginTop: "5px",
          }}
          subtitle
        >
          {dateTimeFormat(updatedAt)}
        </Text>
      </div>
    ),
    action: <ValidatedPopOverMenu orders={orders} history={history} />,
  };
};

export const mapFilterToRequest = (filterState) => {
  const { status, type, productCode, ...fs } = filterState;

  const hasSelectedType = !type?.isSelectedAll && type?.value?.length > 0;
  const hasSelectedStatus = !status.isSelectedAll && status?.value?.length > 0;

  return {
    ...fs,
    stationType: hasSelectedType ? type?.value?.join(",") : undefined,
    status: hasSelectedStatus ? status.value.join(",") : undefined,
    productCode: !productCode.isSelectedAll ? productCode.value.join(",") : undefined,
  };
};
